export enum PaginationType {
   Lined = 'Lined',
   Numeric = 'Numeric',
   None = 'None',
}

export enum AtlPaginationTagNames {
   Pagination = 'atlantis-pagination',
}
